import { Tabs } from 'antd';
import { useTranslation } from 'react-i18next';
import jumpToAnchor from 'utils/jumpToAnchor';

interface ClaimTab {
  translationKey: string;
  key: string;
}
interface ClaimTabProps {
  claimTabs: ClaimTab[];
}

export const ClaimTabs = (props: ClaimTabProps) => {
  const { t } = useTranslation();
  const { claimTabs } = props;

  const items =
    claimTabs?.length > 0
      ? claimTabs.map((claimTab, index) => ({
          label: `${index + 1}. ${t(claimTab.translationKey)}`,
          key: claimTab.key,
        }))
      : [];
  return (
    <Tabs
      tabPosition="right"
      onTabClick={(activeKey, e) => {
        e.preventDefault();
        jumpToAnchor(activeKey);
      }}
      items={items}
    ></Tabs>
  );
};
